// extracted by mini-css-extract-plugin
export default {"wrapper":"ChangeDataWrapper_wrapper__+aWQb","header":"ChangeDataWrapper_header__XIPpP","content":"ChangeDataWrapper_content__+BmwE"};